module.exports = __webpack_public_path__ + "img/xm1.5c421e48.png";